import { APP_ROUTES } from 'constants/routes';
import { decodeURIComponentSafe } from 'helpers/BrowserHelpers';

import { DEFAULT_SEO_IMAGE, getOpenGraphUrl, getPageSeoBreadcrumbs } from './SeoHelpers';

import type { PageSeoProps, TFunction } from 'types';

export function getGoodDeedsPostPageSeo(t: TFunction, post: any, isMobilePreview?: boolean): PageSeoProps {
  if (!post) return { seoProps: undefined, breadcrumbs: undefined };

  const decodedTitle = decodeURIComponentSafe(post.title);
  const description = post.seoDescription;
  const image = post.thumbnailImage?.url;

  return {
    seoProps: {
      title: decodedTitle,
      description,
      openGraph: {
        url: getOpenGraphUrl(),
        description,
        images: image ? [{ url: image }] : DEFAULT_SEO_IMAGE
      },
      noindex: !!isMobilePreview,
    },
    breadcrumbs: getPageSeoBreadcrumbs(t, [
      { name: t('NAVIGATION.BLOG.INSPIRATIE_FRESHFUL.GOOD_DEEDS'), slug: APP_ROUTES.BLOG_GOOD_DEEDS }
    ])
  };
}

export function getGoodDeedsLandingPageSeo(t: TFunction, lp: any, isMobilePreview?: boolean): PageSeoProps {
  if (!lp) return { seoProps: undefined, breadcrumbs: undefined };

  const decodedTitle = decodeURIComponentSafe(lp?.title);
  const description = lp.seoDescription;

  return {
    seoProps: {
      title: decodedTitle,
      description,
      openGraph: {
        url: getOpenGraphUrl(),
        description
      },
      noindex: !!isMobilePreview,
    },
    breadcrumbs: getPageSeoBreadcrumbs(t)
  };
}
